import React from 'react';
import PropTypes from 'prop-types';
import BaseModal from './BaseModal';
import TransactionService from '../../service/TransactionService';
import { buildFailureStatus, buildSuccessStatus, } from '../constants/AlertConstants';
import AsyncActionButton from '../button/AsyncActionButton';

class HistoryNote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      note: '',
      isLoading: false,
    };
  }

  onChange(note) {
    this.setState({
      note,
    });
  }

  onDismiss() {
    return () => this.setState({
      status: null,
    });
  }

  onSubmit(paymentHistoryId, note) {
    this.setState({ isLoading: true, });
    TransactionService.addHistoryNote({ paymentHistoryId, note, })
      .then(() => {
        this.setState({
          status: buildSuccessStatus('Note Added', this.onDismiss()),
        });
      })
      .catch(() => {
        this.setState({
          status: buildFailureStatus('Unable to add Note', this.onDismiss()),
        });
      })
      .finally(() => {
        this.reset();
      });
  }

  reset() {
    this.setState({
      note: '',
      isLoading: false,
    });
  }

  render() {
    const { note, status, isLoading, } = this.state;
    const { paymentHistoryId, } = this.props;
    return (
      <BaseModal buttonLbl="Add Note" title="Add a Transaction Note">
        {status}
        <textarea
          className="form-control"
          value={note}
          onChange={event => this.onChange(event.currentTarget.value)}
        />
        <div className="mt-2">
          <AsyncActionButton
            variant="primary"
            contents="Add"
            onClick={() => this.onSubmit(paymentHistoryId, note)}
            isLoading={isLoading}
          />
        </div>
      </BaseModal>
    );
  }
}

HistoryNote.propTypes = {
  paymentHistoryId: PropTypes.string.isRequired,
};

export default HistoryNote;
